import IconButton from "components/elements/IconButton";
import Table from "components/elements/Table";
import { CLIENT_TYPES, LS_CLONE_CLIENT_KEY } from "core/Constants";
import dataProvider from "core/DataProvider";
import { useEffect, useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import { ReactComponent as EditIcon } from "../../../images/edit.svg";
import IconInput from "components/elements/IconInput";
import utility from "core/Utils";
import toast from "react-hot-toast";
import Exporter from "components/elements/Exporter";

const headerMap = {
  action: "Actions",
  group_id: "GID",
  client_id: "CID",
  client_name: "Client Name",
  group_name: "Group Name",
  client_type: "Client Type",
  manager: "Manager",
  finance_code: "Finance Code",
  total_spot: "Allocated Spot",
  consumed_spots: "Consumed Spots",
  total_user: "Total User",
  tolerance_days: "Tolerance Days",
  back_days: "Back Days",
  auto_csv: "Auto CSV",
  is_multi_advertiser: "Multi Advertiser",
  period_from: "Period From",
  period_to: "Period To",
};

const exportHeader = [
  { key: "group_id", label: "GID" },
  { key: "client_id", label: "CID" },
  { key: "client_name", label: "Client Name" },
  { key: "group_name", label: "Group Name" },
  { key: "client_type", label: "Client Type" },
  { key: "manager", label: "Manager" },
  { key: "finance_code", label: "Finance Code" },
  { key: "total_spot", label: "Allocated Spot" },
  { key: "consumed_spots", label: "Consumed Spots" },
  { key: "total_user", label: "Total User" },
  { key: "tolerance_days", label: "Tolerance Days" },
  { key: "back_days", label: "Back Days" },
  { key: "auto_csv", label: "Auto CSV" },
  { key: "is_multi_advertiser", label: "Multi Advertiser" },
  { key: "period_from", label: "Period From" },
  { key: "period_to", label: "Period To" },
];

const ClientListing = props => {
  const navigate = useNavigate();

  // States
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);

  const token = useOutletContext();

  // Fetchers
  const getClients = async () => {
    try {
      let d = await dataProvider.network.get("clients");
      console.log(d);
      d = d.map(x => {
        x.client_type = CLIENT_TYPES[x.client_type];
        x.auto_csv = x.auto_csv ? "Yes" : "No";
        x.is_multi_advertiser = x.is_multi_advertiser ? "Yes" : "No";

        x.action = (
          <div
            className="action flex flex-v-center"
            onClick={() => editClient(x)}
          >
            <div className="action-button flex flex-center">
              <EditIcon />
            </div>
          </div>
        );

        return x;
      });
      setData(d);
    } catch (error) {
      toast.error("Failed to load client listing");
    } finally {
      setLoading(false);
    }
  };

  // Edit click handler
  const editClient = client => {
    // set details in localstorage
    localStorage.setItem(LS_CLONE_CLIENT_KEY, JSON.stringify(client));
    // redirect to new client page
    navigate("/clients/new");
  };

  // Hooks
  useEffect(() => {
    getClients();
  }, []);

  return (
    <section id="client-list-container">
      <div className="flex">
        <div className="right flex flex-v-center">
          <IconButton
            icon="add"
            text="New Client"
            onClick={_ => {
              localStorage.removeItem(LS_CLONE_CLIENT_KEY);
              navigate("/clients/new");
            }}
          />
        </div>
      </div>
      <div className="box mtop pad-1">
        <div className="flex flex-v-center">
          <h3 className="pad-lr">Clients</h3>
          <div className="right flex flex-v-center">
            <div className="el">
              {loading && (
                <div className="loader">
                  <div className="lds-hourglass"></div>
                </div>
              )}
            </div>
            <div className="el pad-lr">
              <IconInput
                value={search}
                onChange={e => setSearch(e.target.value)}
                placeholder="Search (min 3 character)"
                icon="search"
                style={{ minWidth: "250px" }}
              />
            </div>
            <div className="pad-lr" style={{ marginLeft: "0" }}>
              <Exporter
                format="csv"
                data={data.map(x => ({
                  ...x,
                  period_from: utility.formatDate(x.period_from),
                  period_to: utility.formatDate(x.period_to),
                }))}
                headers={exportHeader}
                filename="clients.csv"
                fileID=""
                clientID={null}
              />
            </div>
          </div>
        </div>
        <div className="mtop">
          <Table
            headers={headerMap}
            data={data.map(x => ({
              ...x,
              period_from: utility.formatDate(x.period_from),
              period_to: utility.formatDate(x.period_to),
            }))}
            search={search}
          />
        </div>
      </div>
    </section>
  );
};

export default ClientListing;
